import { Vacation } from '@work4all/models/lib/Classes/Vacation.entity';
import { VacationDayKind } from '@work4all/models/lib/Enums/VacationDayKind.enum';

export const getVacationDetails = (vacationList: Vacation[] = []) => {
  const vacation = vacationList[0];

  if (!vacation) {
    return {
      isHalfDay: false,
      isFullDay: false,
    };
  }

  const isHalfDay =
    vacation.vacationDayPosition === VacationDayKind.HALBTAGS_NACHMITTAG ||
    vacation.vacationDayPosition === VacationDayKind.HALBTAGS_VORMITTAG;

  const isFullDay = vacation.vacationDayPosition === VacationDayKind.GANZTAGS;

  return {
    isHalfDay,
    isFullDay,
  };
};
